"use strict";
exports.__esModule = true;
exports.SELF_PAY_CONTENT = void 0;
exports.SELF_PAY_CONTENT = {
    BANNER: {
        MESSAGE: 'Make payment by 8pm ET on {{ bpMonth }} {{ordinalBpEndDay}}'
    },
    SELF_PAY: {
        HEADER: 'Submit rent to your property',
        MAIN_TEXT: 'Enter the Flex {{paymentMethodMainText}} in your property’s portal and pay rent before the 5th (or before rent is due).',
        HAVING_ISSUES: 'Having issues? See more options',
        MORE_ACCOUNT_INFO: 'Need more account info?',
        TUTORIAL_HEADER: 'How to use the Flex {{paymentMethod}}'
    },
    HAVING_ISSUES_MODAL: {
        HEADER: 'Having trouble?',
        MAIN_TEXT: 'If you’re having issues with the {{paymentMethod}}, here are some other options',
        DONT_USE_FLEX_MAIN_TEXT: 'Don’t use Flex this month',
        DONT_USE_FLEX_SUB_TEXT: 'Get a refund for your 1st payment',
        SWITCH_TO_DEBIT_CARD_MAIN_TEXT: 'Switch to debit card',
        SWITCH_TO_DEBIT_CARD_SUB_TEXT: 'If your portal isn’t accepting ACH/bank transfers',
        HELP_MAIN_TEXT: 'Help',
        HELP_SUB_TEXT: 'Learn more about using Flex'
    },
    DDA_TUTORIAL: {
        STEP_ONE: 'Log in to your rent payment website or app, and add a new payment method. (Typically you’ll find this in the billing or account sections.)',
        STEP_TWO_ONE: 'Choose',
        STEP_TWO_BOLD_ONE: 'bank account',
        STEP_TWO_TWO: 'as the payment type (some portals may call this',
        STEP_TWO_BOLD_TWO: 'ACH',
        STEP_TWO_THREE: 'or',
        STEP_TWO_BOLD_THREE: 'e-check',
        STEP_TWO_FOUR: 'instead.)',
        STEP_THREE_ONE: 'Enter the',
        STEP_THREE_BOLD_ONE: 'routing number',
        STEP_THREE_TWO: 'and',
        STEP_THREE_BOLD_TWO: 'account number',
        STEP_THREE_THREE: 'shown above, and save the payment method.',
        STEP_FOUR: 'Pay your rent! Make sure you’ve selected the Flex bank account. Allow 1-2 business days for the app to reflect your payment.'
    },
    VC_TUTORIAL: {
        STEP_ONE: 'Log in to your rent payment website or app, and add a new payment method. (Typically you’ll find this in the billing or account sections.)',
        STEP_TWO_ONE: 'Choose',
        STEP_TWO_BOLD: 'debit card',
        STEP_TWO_TWO: 'as the payment type. (Specifically, this is a Mastercard debit card.)',
        STEP_THREE: 'Enter the card information shown above, and save the payment method. Use your current address as the billing address if needed.',
        STEP_FOUR: 'Pay your rent! Make sure you’ve selected the new Flex debit card as your payment method.'
    },
    OPTED_OUT: {
        MAIN_TEXT: "You didn't use Flex this month",
        SUB_TEXT: 'We have refunded your 1st payment to Flex and you will need to pay your rent yourself this month.',
        SUCCESS_MODAL: {
            TITLE: 'Flex won’t pay your rent this month',
            BODY: 'You’ve opted out of Flexible Rent and will pay your rent yourself.'
        }
    },
    PENDING: {
        BEFORE_BP_CLOSE: {
            MAIN_TEXT: "We're confirming your rent submission",
            SUB_TEXT: "If you've submitted rent with the Flex {{paymentMethod}}, we'll notify you when the transaction has been processed. This may take up to 4 days"
        },
        AFTER_BP_CLOSE: {
            MAIN_TEXT: "We're confirming your rent submission",
            SUB_TEXT: "If you've submitted rent with the Flex payment method, we'll notify you when the transaction has been processed. This may take up to 4 days."
        },
        BILL_STATUS_SUBTEXT: 'for confirmation of rent submission',
        PENDING_SCREEN: {
            TITLE: "We're confirming your rent submission",
            PARAGRAPH_1: "You indicated that you would submit your rent to your property using the Flex payment method this month.",
            PARAGRAPH_2: "If you've made a transaction we'll notify you when your rent has been processed. It may take up to 4 days for the Flex app to update.",
            PARAGRAPH_3: "For the latest status, check your property's portal.",
            OPT_OUT_TEXT: "Didn't submit your rent?",
            OPT_OUT_LINK_TEXT: "Refund your 1st payment",
            CTA: 'Done'
        }
    },
    SELF_PAY_START: {
        HEADER: 'Submit rent using a Flex {{paymentMethod}}',
        BODY_ONE: 'We couldn’t pay your rent directly to your property this month. But don’t worry! We’ll provide you with a Flex {{paymentMethod}} with {{amount}} for you to submit your rent.',
        BODY_TWO: 'Enter the Flex {{paymentMethod}} info into your property’s portal and submit rent before the {{bpEndDay}} (or before rent is due).',
        DISCLAIMER_START: 'By continuing, you agree to ',
        CTA: 'Continue'
    },
    DONE_MODAL: {
        TITLE: 'Did you submit your rent?',
        MAIN_TEXT: 'Please confirm that you used the Flex {{paymentMethod}} to submit rent to your property.',
        CONFIRM_CTA: 'Yes, I submitted my rent',
        NOT_YET: 'Not yet'
    },
    SELF_PAY_HELP_MENU: {
        HEADER: 'Need help?',
        OPTION_ONE_DDA: 'Set up the account in your portal',
        OPTION_ONE_VC: 'Set up the debit card in your portal',
        OPTION_TWO: 'Change to Flex debit card',
        OPTION_THREE: 'Refund 1st payment'
    },
    SETUP_BANK_ACCOUNT: {
        HEADER: 'How to set up the Flex bank account in your portal',
        STEP_ONE: 'Log in to your property’s portal, and add a new payment method or start your rent submission. For the payment method, choose',
        STEP_ONE_BOLD: 'bank account',
        STEP_ONE_TWO: '(sometimes called',
        STEP_ONE_BOLD_TWO: 'ACH',
        STEP_ONE_THREE: 'or',
        STEP_ONE_BOLD_THREE: 'e-check.)',
        STEP_TWO: 'Enter the following account information.',
        LABEL_ONE: 'Routing number',
        LABEL_TWO: 'Account number',
        STEP_TWO_CTA: 'More account details',
        STEP_THREE: 'Check if your portal requires account verification.',
        STEP_THREE_CTA: 'Learn how to verify',
        STEP_FOUR: 'You’re ready to submit rent! Make sure you’ve selected the new Flex bank account as your payment method.'
    },
    SETUP_DEBIT_CARD: {
        HEADER: 'How to set up the Flex debit card in your portal',
        STEP_ONE: 'Log in to your property’s portal, and add a new payment method or start your rent submission. For the payment method, choose',
        STEP_ONE_BOLD: 'debit card.',
        STEP_TWO: 'Enter the following card information.',
        STEP_THREE: 'You’re ready to submit rent! Make sure you’ve selected the new Flex debit card as your payment method.',
        CAPTION: 'Tap card number to copy'
    },
    SWITCH_TO_DEBIT: {
        NEW_CONTENT: {
            TITLE: 'Change to Flex debit card',
            CTA: 'Confirm',
            BODY: 'Ensure your portal accepts debit cards before proceeding. Also note:',
            BULLET_ONE: 'You will not be able to switch back and use the Flex bank account this month.',
            BULLET_TWO: 'Some portals charge an additional fee for paying with a debit card.',
            BODY_TWO: 'Please do not proceed if you’ve already submitted your rent using the Flex bank account.',
            LINK: 'Never mind'
        }
    },
    VERIFY_ACCOUNT: {
        HEADER: 'Verifying the Flex bank account',
        QUESTION_ONE: 'How do I know if I need to verify the account?',
        ANSWER_ONE: 'When you add the Flex bank account to your portal for the first time, your portal may ask you to verify the account before you can submit rent.\n\n' +
            'If your portal doesn’t ask for verification, you can proceed directly to submitting your rent.',
        QUESTION_TWO: 'Can I use instant verification?',
        ANSWER_TWO: 'No, we don’t currently support instant verification via bank login. You’ll need to use the manual verification process involving small deposits or a security code.\n\n' +
            'You may need to attempt instant verification a few times before your portal offers manual verification.',
        QUESTION_THREE: 'What do I need to do to complete verification?',
        ANSWER_THREE: 'Your portal will notify you that they’ve sent a small deposit or a security code to the account. We’ll email you the deposit amount or code as soon as we receive it. This typically takes 1-3 business days.\n\n' +
            'If your portal requires 2 small deposits, we’ll send you the amounts in separate emails.',
        QUESTION_FOUR: 'What if my rent is due soon and I can’t wait for the verification process?',
        ANSWER_FOUR: 'If you have the option to switch to the Flex debit card, you can use the debit card for your current rent payment, and complete the verification for next month.\n\n' +
            'Note that your portal may charge an additional fee for paying with a debit card.'
    },
    MORE_ACCOUNT_INFO: {
        HEADER: 'Flex bank account details',
        BODY: 'Use the following details if your portal requires additional account information.',
        ACCOUNT_HOLDER: 'Account holder',
        ACCOUNT_TYPE: 'Account type',
        BANK_NAME: 'Bank name',
        ADDRESS: 'Address',
        PHONE: 'Phone number',
        EMAIL: 'Email'
    },
    SELF_PAY_DETAILS: {
        DDA_HEADER: 'Flex bank account',
        READY_STATUS: 'Ready',
        AVAILABLE: 'available',
        VC_HEADER: 'Flex debit card'
    },
    REFUND_MODAL: {
        HEADER: 'If you’ve decided not to use Flex this month, you can receive a refund.',
        BULLET_ONE: 'Flex will refund your 1st payment. The refund may take 1-3 business days to appear in your account',
        BULLET_TWO: 'Any payments submitted to your property using the Flex bank account or debit card will be returned',
        BULLET_THREE: 'You won’t be able to split your rent this month',
        ACCEPTANCE_TEXT: 'I understand it is my responsibility to pay my rent using my own payment method',
        TITLE: 'Refund 1st payment',
        CTA: 'Confirm',
        LINK_BUTTON_TEXT: 'Never mind',
        SUCCESS_TITLE: 'Flex won’t pay your rent this month',
        SUCCESS_SUBTITLE: 'You’ve opted out of Flexible rent and will pay your rent yourself.'
    }
};
